import React, { Component } from "react";
import PrintReport from "./screens/leStudy/PrintReport";
import englishJson from "./utils/language/leStudy/english.json";
import spanishJson from "./utils/language/leStudy/spanish.json";
import noLanguageJson from "./utils/language/leStudy/noLanguage.json";
import { RESEARCH_TYPE } from "./utils/consts";
import "./PrintReportPage.css";

export default class PrintReportPage extends Component {
  componentDidMount() {
    // Get eals_id from URL parameters
    const params = new URLSearchParams(window.location.search);
    const ealsId = params.get("eals_id");

    if (ealsId) {
      localStorage.setItem("temp_print_eals_id", ealsId);
    }
  }

  render() {
    const formData =
      RESEARCH_TYPE === "LE Study"
        ? localStorage.getItem("ap_language") === "English"
          ? englishJson
          : localStorage.getItem("ap_language") === "Spanish"
            ? spanishJson
            : noLanguageJson
        : englishJson;

    const ealsId =
      new URLSearchParams(window.location.search).get("eals_id") ||
      localStorage.getItem("ap_eals_id");

    return (
      <div className="print-report-page">
        <PrintReport
          eals_id={ealsId}
          formData={formData}
          onClose={() => window.close()}
        />
      </div>
    );
  }
}

